import { useEffect } from 'react';

export const ConfirmCenterModal = ({
  title,
  description,
  cancelText = '취소',
  confirmText = '확인',
  onCancel,
  onConfirm,
  isConfirmLoading = false,
}) => {
  useEffect(() => {
    const prevent = (e) => e.preventDefault();

    document.addEventListener('touchmove', prevent, { passive: false });

    return () => {
      document.removeEventListener('touchmove', prevent);
    };
  }, []);

  return (
    <div className="confirm-center-modal__backdrop">
      <div className="confirm-center-modal">
        <div className="confirm-center-modal__content">
          <h3 className="confirm-center-modal__title">{title}</h3>

          {description && (
            <p className="confirm-center-modal__desc">{description}</p>
          )}
        </div>

        <div className="confirm-center-modal__buttons">
          <button
            type="button"
            className="confirm-center-modal__btn confirm-center-modal__btn--cancel"
            onClick={onCancel}
            disabled={isConfirmLoading}
          >
            {cancelText}
          </button>

          <button
            type="button"
            className={`confirm-center-modal__btn confirm-center-modal__btn--confirm ${isConfirmLoading ? 'is-loading' : ''
              }`}
            onClick={onConfirm}
            disabled={isConfirmLoading}
          >
            {isConfirmLoading ? (
              <div className="loader-st01" />
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
